import React from 'react';
import { withResolver } from 'components/common';
import { FormGroup } from 'components/common/Forms';
import { compose, withState } from 'recompose';
import { Control } from 'react-redux-form';
import { Card, CardBody } from 'reactstrap';
import { Creatable } from 'react-select';

export const InstallerFeatures = ({ features, item, readOnly}) => (
  <FormGroup>
    <Card>
      <CardBody>
        <FormGroup label="Features" >
          <Control.select
            model=".features"
            placeholder="None Set"
            component={Creatable}
            options={features}
            multi
            labelKey="installation_type"
            valueKey="id"
            disabled={readOnly || item.is_all_features}
          />
        </FormGroup>
        <FormGroup label="All Features" check disabled={readOnly}>
          <Control.checkbox 
            model=".is_all_features"
          />
        </FormGroup>
      </CardBody>
    </Card>
  </FormGroup>
);

const enhance = compose(
  withState('features', 'setFeatures', null),
  withResolver({
      features: () => client => client.get('installation_types'),
  }, {
    onResolved: ({ setFeatures }) => ({ features }) => {
      setFeatures(features);
    }
  })
);

export default enhance(InstallerFeatures);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerFeatures.jsx